import { render, staticRenderFns } from "./ScanVotingPaperDialog.vue?vue&type=template&id=95f30fc2&scoped=true"
import script from "./ScanVotingPaperDialog.vue?vue&type=script&lang=js"
export * from "./ScanVotingPaperDialog.vue?vue&type=script&lang=js"
import style0 from "./ScanVotingPaperDialog.vue?vue&type=style&index=0&id=95f30fc2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f30fc2",
  null
  
)

export default component.exports